// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
// NEW PAGE: src/pages/Bots.jsx
// Página independiente para administrar (CRUD) bots.
// -----------------------------------------------------------------------------
import BotsPanel from "../components/bots/BotsPanel";


export default function Bots() {
    return (
        <div className="container" style={{ padding: 16 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                <h2 style={{ margin: 0 }}>Administrar Bots</h2>
                <a className="btn" href="/settings">Volver a Settings</a>
            </div>
            <BotsPanel />
        </div>
    );
}